import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
	selector: 'page-case-study',
	templateUrl: 'case-study.html',
})

export class CaseStudyPage {

	displayData: boolean = false;
	study: any;
	studyTitle: string;
	studyText: string;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams) {
			this.study = this.navParams.data;
			console.log(this.study);
	}

	ionViewDidLoad() {
		if(this.study.client == "University of St Andrews"){
			this.studyTitle = this.study.client;
			this.studyText = "<p>The University of St Andrews uses eCom Scotland's eMentoring solution eNetCOP™ to promote the wider uptake of Higher Education among those groups that are traditionally under-represented at university.  <p/><p> School and college pupils are given the opportunity to spend a day shadowing an undergraduate student at lectures, tutorials and seminars. They can then join the eMentoring network to receive help and advice from students on a secure online forum.</p>"
		} 

		this.displayData = true;
	}

}



// WEBPACK FOOTER //
// ./src/pages/topics/case-studies/case-study/case-study.ts